import { HOME_SCREEN_TABLE_TYPE } from '@/homescreen/homescreen.constants';
import { sqHomeScreenStore } from '@/core/core.stores';
import { loadTable, setSearchParams } from '@/homescreen/homescreen.actions';

export function loadSearchTable({
  searchParams = undefined as object | undefined,

  isCurrentFolderNested = false,
  advancedSearchSelectedFolder = '',
  locationChangedInAdvanced = false,
  breadcrumbClicked = false,
}) {
  const table = HOME_SCREEN_TABLE_TYPE.SEARCH;
  const searchSort = sqHomeScreenStore.getSortForTable(table);
  const sortOrder = `${searchSort.sortProperty} ${searchSort.sortAsc ? 'asc' : 'desc'}`;
  if (searchParams) {
    searchParams = { ...searchParams, sortOrder };
  } else {
    setSearchParams({ ...sqHomeScreenStore.searchParams, sortOrder });
    searchParams = sqHomeScreenStore.searchParams;
  }
  return loadTable({
    searchParams,
    table,
    isCurrentFolderNested,
    advancedSearchSelectedFolder,
    locationChangedInAdvanced,
    breadcrumbClicked,
  });
}

export const exposedForTesting = {
  loadSearchTable,
};
